import { timerDelay } from 'common/helpers/timerDelay';
import { useRef, useState, useCallback, useEffect, RefObject } from 'react';

export interface UseContainerSizeReturnProps {
  containerRef: React.RefObject<HTMLDivElement | SVGElement>;
  width: number;
  height: number;
}

export const useContainerSize = (delay = 0, ref?: RefObject<HTMLDivElement>): UseContainerSizeReturnProps => {
  const newRef =  useRef<HTMLDivElement | SVGElement>(null);
  const containerRef = ref || newRef 
  const [dimensions, set] = useState<{ width: number; height: number }>({ width: 0, height: 0 });
  
  const { width, height } = dimensions;

  const setDimensions = useCallback(() => {
    
    let setterDelay = delay

    if (containerRef?.current) {
  
      const newWidth = containerRef.current instanceof SVGElement
        ? containerRef.current.getBoundingClientRect().width
        : containerRef.current.offsetWidth;
      const newHeight = containerRef.current instanceof SVGElement
        ? containerRef.current.getBoundingClientRect().height
        : containerRef.current.offsetHeight;

      const setter = () => {
        set(( ) => {
            return { width: newWidth, height: newHeight };          
        })
        
      }      

      if (width === 0) setterDelay = 0
      return timerDelay(setterDelay, setter);

    }},[containerRef])
      //timerDelay(delay, , []);

  useEffect(() => {
    if (!containerRef?.current) return
    const observer = new ResizeObserver(() => setDimensions());
    observer?.observe(containerRef.current);
    return () => {
      containerRef?.current && observer?.unobserve(containerRef.current);
      observer?.disconnect();
    };
  }, [setDimensions]);
  return { containerRef, width, height };
};

export default useContainerSize;